export const SpanishJoi = {
  root: 'value',
  key: '"{{!label}}" ',
  messages: {
    wrapArrays: true,
  },
  any: {
    unknown: 'no está permitido',
    invalid: 'contiene un valor inválido',
    empty: 'no puede estar vacio',
    required: 'es obligatorio',
    allowOnly: 'debe ser uno de los siguientes valores {{valids}}',
    default: 'threw an error when running default method',
  },
  alternatives: {
    base: 'not matching any of the allowed alternatives',
    child: null,
  },
  array: {
    base: 'must be an array',
    includes: 'at position {{pos}} does not match any of the allowed types',
    includesSingle:
      'single value of "{{!label}}" does not match any of the allowed types',
    includesOne: 'at position {{pos}} fails because {{reason}}',
    includesOneSingle: 'single value of "{{!label}}" fails because {{reason}}',
    includesRequiredUnknowns:
      'does not contain {{unknownMisses}} required value(s)',
    includesRequiredKnowns: 'does not contain {{knownMisses}}',
    includesRequiredBoth:
      'does not contain {{knownMisses}} and {{unknownMisses}} other required value(s)',
    excludes: 'at position {{pos}} contains an excluded value',
    excludesSingle: 'single value of "{{!label}}" contains an excluded value',
    min: 'must contain at least {{limit}} items',
    max: 'must contain less than or equal to {{limit}} items',
    length: 'must contain {{limit}} items',
    ordered: 'at position {{pos}} fails because {{reason}}',
    orderedLength:
      'at position {{pos}} fails because array must contain at most {{limit}} items',
    ref: 'references "{{ref}}" which is not a positive integer',
    sparse: 'must not be a sparse array',
    unique: 'position {{pos}} contains a duplicate value',
  },
  boolean: {
    base: 'must be a boolean',
  },
  date: {
    base: 'must be a number of milliseconds or valid date string',
    format: 'must be a string with one of the following formats {{format}}',
    strict: 'must be a valid date',
    min: 'must be larger than or equal to "{{limit}}"',
    max: 'must be less than or equal to "{{limit}}"',
    isoDate: 'must be a valid ISO 8601 date',
    timestamp: {
      javascript: 'must be a valid timestamp or number of milliseconds',
      unix: 'must be a valid timestamp or number of seconds',
    },
    ref: 'references "{{ref}}" which is not a date',
  },
  number: {
    base: 'debe ser un número',
    min: 'debe ser mayor o igual a {{limit}}',
    max: 'debe ser menor o igual a {{limit}}',
    less: 'debe ser menor a {{limit}}',
    greater: 'debe ser mayor a {{limit}}',
    float: 'debe tener decimales',
    integer: 'debe ser un entero',
    negative: 'debe ser un número negativo',
    positive: 'debe ser un número positivo',
    precision: 'no debe tener más de {{limit}} decimales',
    ref: 'references "{{ref}}" which is not a number',
    multiple: 'debe ser un multiplo de {{multiple}}',
  },
  string: {
    base: 'debe ser texto',
    min: 'debe tener al menos {{limit}} caracteres',
    max: 'debe tener máximo {{limit}} caracteres',
    length: 'length must be {{limit}} characters long',
    alphanum: 'must only contain alpha-numeric characters',
    token: 'must only contain alpha-numeric and underscore characters',
    regex: {
      base:
        'with value "{{!value}}" fails to match the required pattern: {{pattern}}',
      name: 'with value "{{!value}}" fails to match the {{name}} pattern',
      invert: {
        base:
          'with value "{{!value}}" matches the inverted pattern: {{pattern}}',
        name: 'with value "{{!value}}" matches the inverted {{name}} pattern',
      },
    },
    email: 'debe ser un correo válido',
    uri: 'debe ser una uri válida',
    uriRelativeOnly: 'must be a valid relative uri',
    uriCustomScheme:
      'debe comenzar con alguno de los siguientes valores: {{scheme}}',
    isoDate: 'must be a valid ISO 8601 date',
    guid: 'must be a valid GUID',
    hex: 'must only contain hexadecimal characters',
    base64: 'must be a valid base64 string',
    hostname: 'must be a valid hostname',
    normalize: 'must be unicode normalized in the {{form}} form',
    lowercase: 'must only contain lowercase characters',
    uppercase: 'must only contain uppercase characters',
    trim: 'must not have leading or trailing whitespace',
    creditCard: 'must be a credit card',
    ref: 'references "{{ref}}" which is not a number',
    ip: 'must be a valid ip address with a {{cidr}} CIDR',
    ipVersion:
      'must be a valid ip address of one of the following versions {{version}} with a {{cidr}} CIDR',
  },
};

export const parseJoiMessages = (errors) => {
  if (!errors) {
    return null;
  }

  const messages = {};

  errors.forEach((value) => {
    if (!{}.hasOwnProperty.call(messages, value.path[0])) {
      messages[value.path[0]] = value.message;
    }
  });

  return messages;
};



// WEBPACK FOOTER //
// ./src/utils/joi.js